/**
 * Genera un código de sesión único.
 * Formato: YYYY-MM-DD-timestamp (ej: 2026-03-26-1743023456789)
 *
 * Se usa para agrupar en una "sesión" todos los cambios (inserts) enviados
 * a `animales_historico` dentro de una misma operación, de modo que todo
 * cambio quede reflejado en una sesión.
 *
 * Compartido entre web y mobile (mobile importa vía @shared).
 *
 * @param now Fecha base para el código. Por defecto la fecha actual.
 */
export function generateSessionCode(now: Date = new Date()): string {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const timestamp = now.getTime();
  return `${year}-${month}-${day}-${timestamp}`;
}
